import { Fragment, useMemo } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { getVideoAnalysis } from "actions/spyAdvancedActions";
import useCallApi from "hook/useCallApi";
import useInViewport from "hook/useInViewport";
import { formatNumberShort } from "components/Function";

const DashboardOverview = ({ video, getVideoAnalysis }) => {
    const { t } = useTranslation();
    const [ref, inView] = useInViewport({ threshold: 0.2, once: true });

    const paramOverview = useMemo(() => {
        return {
            id: video.video_id,
            tag: "basic.overview",
        };
    }, [video.video_id]);

    const { data: overview, loading } = useCallApi(getVideoAnalysis, paramOverview, inView);

    return (
        <Fragment>
            <div className="card mt-5 mb-5 mb-xl-10 pb-8" ref={ref}>
                <div className="card-header border-0 cursor-pointer align-items-center">
                    <div className="card-title m-0">
                        <h3 className="fw-bold m-0">{t("Overview")}</h3>
                    </div>
                </div>
                <div>
                    <div className="d-flex justify-content-between align-items-center gap-8 m-4 px-20">
                        {loading ? (
                            <div className="w-100 d-flex justify-content-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only"></span>
                                </div>
                            </div>
                        ) : (
                            overview?.data?.map((v, k) => (
                                <Fragment key={k}>
                                    <div className="text-center">
                                        <div className="fw-bold fs-2">
                                            {v?.prefix} {formatNumberShort(v?.value)}
                                        </div>
                                        <div className="text-muted small">{v?.label}</div>
                                    </div>
                                    {overview?.data.length !== k + 1 && <div className="vr"></div>}
                                </Fragment>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default connect(null, { getVideoAnalysis })(DashboardOverview);
